// extracted by mini-css-extract-plugin
export default {"roleBar":"ProjectGroupRow-module__roleBar___VB6hD","scheduledHours":"ProjectGroupRow-module__scheduledHours___YKKO_"};